export default __webpack_public_path__ + "static/media/current-check-in-container.85abf5c9.webp";